import React, { Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import arrowDown from '../../../images/arrow-down-black.svg';
import SkyportParked from './ParkingLotData/Skyport/SkyportParked';
import SkyportWalking from './ParkingLotData/Skyport/SkyportWalking';
import SkyportParking from './ParkingLotData/Skyport/SkyportParking';
import SkyportEnter from './ParkingLotData/Skyport/SkyportEnter';

import './driverFaq.css';

const SkyportManhattan = () => (
  <Fragment>
    {SkyportManhattanData.map(({ title, Content }, index) => (
      <div className="faq__panel faq__panel__margin" key={title}>
        <div
          className="faq__heading collapsed"
          data-toggle="collapse"
          href={`#ParkingFaq${index}`}>
          <h4 className="faq__panel--title">{title}</h4>
          <FontAwesomeIcon className="faq__arrow" icon={faChevronDown} />
          <img className="faq__arrow hide" src={arrowDown} alt="arrow" />
        </div>
        <div id={`ParkingFaq${index}`} className="panel-collapse collapse">
          <div className="faq__panel--body">
            <Content key={title} />
          </div>
        </div>
      </div>
    ))}
  </Fragment>
);

export default SkyportManhattan;

const SkyportManhattanData = [
  {
    title: 'Where are the cars parked?',
    Content: () => <SkyportParked />
  },
  {
    title: 'How do I access the parking lot by walking?',
    Content: () => <SkyportWalking />
  },
  {
    title:
      'How do I access the parking lot with my personal car (free parking)?',
    Content: () => <SkyportParking />
  },
  {
    title:
      'How do I enter/exit the parking lot with an Autzu vehicle using the key card?',
    Content: () => <SkyportEnter />
  }
];



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/SkyportManhattan.js